import React from 'react';
import { changeFilter } from '../services/navigation';
import PropTypes from 'prop-types';

function DropdownItem({search, title, options, name, istaxonomy, settings}) {



	const change = e => {			
		changeFilter(search, name, e.target.value);
	};

	var languageDropdown = options.children;

	if (settings != undefined)
	{
		settings.defaultLanguage = {name: "English", key: "0/534/556"};
	}
	

	if (settings && settings.microsite !== undefined && settings.microsite != "" ) {
		switch (settings.microsite) {
			case 'TWIMiddleEast':
				//languageDropdown = languageDropdown.filter(el=> el.name == "English" || el.name == "Arabic");
				languageDropdown = languageDropdown.filter(el=> el.name == "Arabic" );
				break;
	
			case 'TWISEA':
				languageDropdown = languageDropdown.filter(el=> el.name == "English" ||  el.name == "Bahasa" );
				break;
	
			case 'TWIIndia':
				languageDropdown = languageDropdown.filter(el=> el.name == "English" ||  el.name == "Hindi" );
				break;
			
			case 'TWICertification':
				languageDropdown = languageDropdown.filter(el=> el.name == "English" );
				break;

			default :
				languageDropdown = languageDropdown.filter(el=> el.name == "English");
				break;
		}
	} else
	{
		languageDropdown = languageDropdown.filter(el=> el.name == "English");
	}


	

	if(istaxonomy && name == "language" && languageDropdown.length <= 1 )
	{
		return (<div></div>);
	}


	else if(istaxonomy && name == "language" && languageDropdown.length > 1 )
	{
		if(search.language === undefined)
		{
		changeFilter(search, 'language', settings.defaultLanguage.key);	
		}



		return (

			<div>
					<div className="filter__text">
						Select a language
					</div>  

				<div className="filter filter__dropdown">
					<label htmlFor={name} className="search__label visuallyhidden">{title}</label>
					{/* <select className="filter__element" id={name} name={name} value={search[name]} onChange={change}> */}
					<select className="filter__element" id={name} name={name} value={search[name]} onChange={change}> 

							{<option value="">{title}</option>}

							{languageDropdown.map((filter) => (<option key={filter.key} value={filter.key} >{filter.name}</option>))}
					</select>
				</div>
			</div>
		);
	} 
	
	else if (istaxonomy && name != "language")
	{
		return (
			<div className="filter filter__dropdown">
				<label htmlFor={name} className="search__label visuallyhidden">{title}</label>
				<select className="filter__element" id={name} name={name} value={search[name]} onChange={change}>
					{<option value="">{title}</option>}

					{options && options.children && options.children.map((filter) => (<option key={filter.key} value={filter.key}>{filter.name}</option>))}		
					
					</select>
			</div>
		);
	}

	return (
		<div className="filter filter__dropdown">
			<label htmlFor={name} className="search__label visuallyhidden">{title}</label>
			<select className="filter__element" id={name} name={name} value={search[name]} onChange={change}>
				<option value="">{title}</option>
				{options.length >0 && options.map((key) => (<option key={key} value={key}>{key}</option>))}
			</select>
		</div>
	);
}

DropdownItem.propTypes = {
    search: PropTypes.object,
    title: PropTypes.string,
	options: PropTypes.object,
	name: PropTypes.string,
	istaxonomy: PropTypes.bool,
	settings: PropTypes.object
};

export default DropdownItem;